import { render } from "./ProcessSustainTableCt.vue?vue&type=template&id=232dc258"
import script from "./ProcessSustainTableCt.vue?vue&type=script&lang=js"
export * from "./ProcessSustainTableCt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__